module.exports = __webpack_public_path__ + "static/00_Front-ef5e6570887f0a37dd2f8dfa5e5246c0.jpg";